import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/get-started-confirmed";
import { buildNoindexHead } from "@/lib/noindex-seo";

export const Route = createFileRoute("/get-started-confirmed")({
  head: () => buildNoindexHead("You're Booked In", "/get-started-confirmed"),
  component: Page,
});
